module.exports = __webpack_public_path__ + "img/thank-you-bg-image.ef6f8a2c.svg";